import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import { ChartsHttpService } from 'app/charts-dashboard/services/charts-http.service';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import {
  ChartTypeEnum,
  Datetime
} from 'app/charts-dashboard/interfaces/chart.interface';
import { ChartsCommonService } from 'app/charts-dashboard/services/charts-common.service';
import { takeUntil } from 'rxjs/operators';
import { Destroyer } from 'app/common/utils';
import { CommonService } from 'app/core/services/common.service';
import { locale } from './locale';
import {
  CardTypeEnum,
  IChartDialog
} from 'app/charts-dashboard/interfaces';
import { ICard } from '../../../state/card';
import { ChartsDashboardQuery } from 'app/charts-dashboard/state/dashboard';
import { ID } from '@datorama/akita';
import { ChartsDashboardCardQuery } from 'app/charts-dashboard/state/card';
import { getAllInstruments } from '@iv/store/instruments/instrument.reducer';
import { ChartsDashboardStateService } from '../../../state/charts-dashboard-state.service';
import { ChartsDialogsService } from '../../../services/charts-dialogs.service';

@Component({
  selector: 'iv-live-card-chart',
  templateUrl: './card-chart.component.html',
  styleUrls: ['./card-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardChartComponent extends Destroyer implements OnInit, OnDestroy {

  constructor(
    private readonly chartsService: ChartsHttpService,
    private readonly chartsCommonService: ChartsCommonService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly commonService: CommonService,
    private readonly elementRef: ElementRef,
    private readonly renderer2: Renderer2,
    private readonly dashboardQuery: ChartsDashboardQuery,
    private readonly cardsQuery: ChartsDashboardCardQuery,
    private readonly stateService: ChartsDashboardStateService,
    private readonly chartsDialogsService: ChartsDialogsService,
    @Inject(Injector) private readonly injector: Injector,
    @Inject(AppStore) private store: Redux.Store<AppState>
  ) {
    super();
  }

  @Input()
  public cardId: ID;

  public card: ICard<ID>;
  public ChartTypeEnum = ChartTypeEnum;
  public CardTypeEnum = CardTypeEnum;
  public timestampToDateTime: Datetime;
  public isFullScreenMode: boolean;
  public locale = locale;
  public skipSettingTimestamp: boolean;

  public ngOnInit(): void {
    this.cardSubscription();
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }

  public addChartToCard(card: ICard<ID>): void {
    if (card.type !== CardTypeEnum.ADD_NEW_CARD) return;

    const data: IChartDialog = {
      chartVariant: null,
      listChartTypes: this.stateService.allChartTypes$,
      instruments: getAllInstruments(this.store.getState())
    };

    this.chartsDialogsService.createAddChartDialog(this.injector, data);
  }

  public fullScreenModeChanges(mode: boolean): void {
    this.isFullScreenMode = mode;
    mode
      ? this.renderer2.addClass(this.elementRef.nativeElement, 'fake-full-screen')
      : this.renderer2.removeClass(this.elementRef.nativeElement, 'fake-full-screen');
    // TODO: После того как избавимся от резины и вернуть браузерный нативный фулл-скрин
    // mode ? this.elementRef.nativeElement.requestFullscreen() : document?.exitFullscreen();
  }

  public skipTimestampChanges(skip: boolean): void {
    this.skipSettingTimestamp = skip;
  }

  private cardSubscription(): void {
    this.cardsQuery.selectEntity(this.cardId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((card: ICard<ID>) => {
        this.card = card;
        this.fullScreenModeChanges(this.card?.fullscreen);
        this.changeDetectorRef.detectChanges();
      });
  }
}
